import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthDomainModule } from '@p2p/auth/domain';

import { AuthApiService } from './services/auth-api.service';

@NgModule({
    imports: [CommonModule, AuthDomainModule],
    providers: [AuthApiService]
})
export class AuthApiModule {}
